'use strict';

/**
 * MapWrapperFactory
 * 
 * @description Initializes a new `mapWrapper`. A `mapWrapper` is used by the 
 * application implementing `sbMap` to access a specific instance of a map and
 * manipulate it.
 */

var MapWrapperFactory = function ($q, MapActions, MapStore, LayerUtil) {
  
  function MapWrapper (mapId) {
    this.mapId = mapId;
    this.Actions = MapActions.get(mapId);
    this.Store = MapStore.get(mapId);
  }

  MapWrapper.prototype = {

    /**
     * Initializes the map wrapper
     * 
     * @return {Promise.<Object>}
     */
    init: function () {
      var Store = this.Store;
      var Actions = this.Actions;

      return Store.getMap()
      .then(function (map) {
        this.map = map;

        // TODO @andre default styles should be passed in here
        this.drawTool = LayerUtil.Draw.create(map, Actions, Store);
        return $q.resolve();
      }.bind(this));  
    },

    getMap: function () {
      return this.Store.getMap();
    },

    getActiveLeafletLayer: function () {
      // TODO
    },

    // ## Draw Methods

    draw: function (type, options) {
      var promise;
      var wrapper = this;

      if (!this.map) {
        promise = this.init();
      } else {
        promise = $q.resolve();
      }

      return promise
      .then(function () {
        return wrapper.drawTool.draw(type, options);
      });
    },

    cancelDraw: function () {
      if(this.drawTool) {
        return this.drawTool.cancel();
      }
    }
  };

  return {
    create: function (mapId) {
      return new MapWrapper(mapId);
    },
  };
};

MapWrapperFactory.$inject = ['$q', 'sbMapActions', 'sbMapStore', 'sbMapLayerUtil'];
module.exports = MapWrapperFactory;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/MapWrapper.js